import {
  brokerConnectModalAtom,
  brokerSelectModalAtom,
  guideModalAtom,
  technicalSupportModalAtom,
} from "@/Atoms/modal/DialogueAtoms";
import React from "react";
import { useRecoilState } from "recoil";
import BrokerConnectModal from "../common/BrokerConnectModal";
import TechnicalRequestModal from "../common/TechnicalRequestModal";
import GuideModal from "../common/GuideModal";
import BrokerSelectionModal from "../common/BrokerSelectionModal";

interface DialogueWrapperProps {
  children?: React.ReactNode;
}

const DialogueWrapper = ({ children }: DialogueWrapperProps) => {
  const [showConnectForm, setShowConnectForm] = useRecoilState(
    brokerConnectModalAtom
  );
  const [showTechnicalRequest, setShowTechnicalRequest] = useRecoilState(
    technicalSupportModalAtom
  );
  const [showGuideModal, setShowGuideModal] = useRecoilState(guideModalAtom);
  const [showSelectForm, setShowSelectForm] = useRecoilState(
    brokerSelectModalAtom
  );

  return (
    <div>
      {showConnectForm.isOpen && <BrokerConnectModal />}
      {showTechnicalRequest?.isOpen && <TechnicalRequestModal />}
      {showGuideModal?.isOpen && <GuideModal />}
      {showSelectForm?.isOpen && <BrokerSelectionModal></BrokerSelectionModal>}
      <div>{children}</div>
    </div>
  );
};

export default DialogueWrapper;
